import moment from 'moment'

export default {
    namespaced: true,
    state: {
        onlyRebooking: false,
        searchString: null,
        type: null,
        changes: false,
        updatedMeetings: {},
        errors: {},
        changedMeetings: false,
        teams: [],
        team: null,
        salesAgents: [],
        salesAgent: null,
        bookingAgents: [],
        bookingAgentOrgCode: null,
        bookingCampaigns: [],
        bookingCampaign: null,
        saving: false,
        period: 'I dag',
        statsPeriod: 'I dag',
        range: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        statsRange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        filters: {
            type: null,
            status: null,
            result: null,
            offerStatus: null,
            offerResult: null,
            salesAgent: null
        },
        meetingDatePresets: [
            "I dag",
            "I morgen",
            "I går",
            "Denne uge",
            "Næste uge",
            "Sidste uge",
            "Denne måned",
            "Næste måned",
            "Sidste måned",
            "Dette år",
            "Selvvalgt"
        ],
        meetingHeaders: [
            {
                header: 'Mødetype',
                cols: 1
            },
            {
                header: 'Kundens navn',
                cols: 2
            },
            {
                header: 'Telefon',
                cols: 1
            },
            {
                header: 'Mødedato',
                cols: 2
            },
            {
                header: 'Tidspunkt',
                cols: 1
            },
            {
                header: 'Agentur',
                cols: 3
            },
            {
                header: 'Status',
                cols: 2
            }
        ],
        offerHeaders: [
            {
                header: 'Mødetype',
                cols: 1
            },
            {
                header: 'Kundens navn',
                cols: 2
            },
            {
                header: 'Telefon',
                cols: 1
            },
            {
                header: 'Opfølgningsdato',
                cols: 3
            },
            {
                header: 'Agentur',
                cols: 3
            },
            {
                header: 'Status på tilbud',
                cols: 2
            }
        ],
        projects: [
            {
                text: 'Ønskebørn',
                value: 'children'
            },
            {
                text: 'Petworld',
                value: 'petworld'
            },
            {
                text: 'Facebook',
                value: 'facebook'
            },
            {
                text: 'Canvas',
                value: 'canvas'
            },
            {
                text: 'Bestående kunder',
                value: 'existing'
            }
        ],
        types: [
            {
                text: 'Alle',
                value: null
            },
            {
                text: 'Telefon',
                value: 'tele'
            },
            {
                text: 'Fysisk',
                value: 'physical'
            },
            {
                text: 'Online',
                value: 'online'
            }
        ],
        typeMap: {
            tele: 'fa-phone',
            physical: 'fa-home',
            online: 'fa-globe'
        },
        reBookPermissions: [
            {
                text: 'Ingen kontakt',
                value: true
            },
            {
                text: 'Vil ikke kontaktes igen',
                value: false
            }
        ],
        statuses: [
            {
                text: 'Åben',
                value: 'open'
            },
            {
                text: 'Gennemført',
                value: 'completed'
            },
            {
                text: 'Aflyst',
                value: 'canceled'
            },
            {
                text: 'Reklamation',
                value: 'complaint'
            }
        ],
        results: [
            {
                text: 'Salg',
                value: 'sale'
            },
            {
                text: 'Tilbud',
                value: 'offer'
            },
            {
                text: 'Afslået',
                value: 'declined'
            }
        ],
        offerStatuses: [
            {
                text: 'Åbent',
                value: 'open'
            },
            {
                text: 'Behandlet',
                value: 'closed'
            }
        ],
        offerResults: [
            {
                text: 'Salg',
                value: 'sale'
            },
            {
                text: 'Afslået',
                value: 'declined'
            }
        ]
    },
    getters: {
        teams: state => [{ text: 'Alle', value: null }, { text: 'Tryg', value: 'tryg' }, { text: 'Alka', value: 'alka' }, ...state.teams],
        salesAgents: state => [{ text: 'Alle', value: null }, ...state.salesAgents],
        bookingAgents: state => [{ text: 'Alle', value: null }, ...state.bookingAgents],
        bookingCampaigns: state => [{ text: 'Alle', value: null }, ...state.bookingCampaigns]
    },
    mutations: {
        setFilters: (state, route) => {
            if (route === 'offers') {
                state.filters.status = 'completed'
                state.filters.result = 'offer'
            } else {
                state.filters.status = null
                state.filters.result = null
                state.filters.offerStatus = null
                state.filters.offerResult = null
            }
        },
        setRange: (state, {range, preset}) => {
            if (preset === "I dag") {
                // state.range = {
                //     startDate: moment()
                //         .format("YYYY-MM-DD"),
                //     endDate: moment()
                //         .format("YYYY-MM-DD")
                // };
                state[range] = [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
            } else if (preset === "I morgen") {
                state[range] = [
                    moment()
                        .add(1, 'd')
                        .format("YYYY-MM-DD"),
                    moment()
                        .add(1, 'd')
                        .format("YYYY-MM-DD")
                    ];
            } else if (preset === "I går") {
                state[range] = [
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, 'd')
                        .format("YYYY-MM-DD")
                    ];
            } else if (preset === "Denne uge") {
                state[range] = [
                    moment()
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Næste uge") {
                state[range] = [
                    moment()
                        .add(1, "weeks")
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .add(1, "weeks")
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste uge") {
                state[range] = [
                    moment()
                        .subtract(1, "weeks")
                        .startOf("isoweek")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "weeks")
                        .endOf("isoweek")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Denne måned") {
                state[range] = [
                    moment()
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("month")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Næste måned") {
                state[range] = [
                    moment()
                        .add(1, "month")
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .add(1, "month")
                        .endOf("month")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Sidste måned") {
                state[range] = [
                    moment()
                        .subtract(1, "month")
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    moment()
                        .subtract(1, "month")
                        .endOf("month")
                        .format("YYYY-MM-DD")
                ];
            } else if (preset === "Dette år") {
                state[range] = [
                    moment()
                        .startOf("year")
                        .format("YYYY-MM-DD"),
                    moment()
                        .endOf("year")
                        .format("YYYY-MM-DD")
                ];
            }
        }
    }
}